import { Component, inject, EventEmitter, Input, Output } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button, ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlanoCurricularCadastrarEditarComponent } from './components/plano-curricular-cadastrar-editar/plano-curricular-cadastrar-editar.component';
import { PlanoCurricularDisciplinaCadastrarEditarComponent } from './components/plano-curricular-disciplina-cadastrar-editar/plano-curricular-disciplina-cadastrar-editar.component';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ApiService } from '@core/providers/http';
import {
  PlanoCurricularService,
  DisciplinaService,
  PlanoCurricularDisciplinaService,
  PeriodoService,
  TipoPeriodoService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { TableComponent } from '@app/shared/components/table/table.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Pagination } from '@app/shared/model/pagination.model';
import { TableColumn } from '@app/shared/components/table/table.component';
import { finalize, Observable } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Message } from 'primeng/message';

@Component({
  selector: 'app-instituicoes-ensino-detalhe-curso',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    AccordionModule,
    FormsModule,
    ReactiveFormsModule,
    PlanoCurricularCadastrarEditarComponent, // Inclui o componente no módulo
    PlanoCurricularDisciplinaCadastrarEditarComponent, // Inclui o componente no módulo,
    Button,
    TableComponent,
    DataVoidComponent,
    ToastModule,
    ConfirmDialogModule,
    Message,
  ],
  providers: [
    ApiService,
    PlanoCurricularService,
    DisciplinaService,
    PlanoCurricularDisciplinaService,
    PeriodoService,
    TipoPeriodoService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './instituicoes-ensino-detalhe-curso.component.html',
  styleUrls: ['./instituicoes-ensino-detalhe-curso.component.scss'],
})
export class InstituicoesEnsinoDetalheCursoComponent {
  @Input() curso: any | null = null;
  @Output() onCloseModal = new EventEmitter<boolean>();
  ref = inject(DynamicDialogRef);
  confirmationService = inject(ConfirmationService);
  messageService = inject(MessageService);
  planoCurricularService = inject(PlanoCurricularService);
  planoCurricularDisciplinaService = inject(PlanoCurricularDisciplinaService);
  periodoService = inject(PeriodoService);
  tipoPeriodoService = inject(TipoPeriodoService);
  disciplinaService = inject(DisciplinaService);
  planoCurricular: any = null; // Plano Curricular atual
  disciplina: any = null; // Disciplina atual
  visibleDisciplinaForm: boolean = false; // Controle para modal de disciplinas
  visiblePlanoCurricularForm: boolean = false; // Controle para modal de plano curricular
  disciplinaOptions: any[] = []; // Opções de disciplinas
  pagination: Pagination<any> = new Pagination<any>();
  activeIndex: any = -1;
  periodoList: any[] = [];
  tipoPeriodoList: any[] = [];
  actions: MenuItem[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: ($event: any) => this.editDisciplina($event.item.data),
    },
    {
      label: 'Excluir',
      icon: 'pi pi-trash',
      command: ($event: any) =>
        this.confirmarRemocaoDisciplina($event.item.data),
    },
  ];
  columns: TableColumn[] = [
    { field: 'disciplina', header: 'Disciplina' },
    { field: 'regime', header: 'Regime' },
    { field: 'cargaHoraria', header: 'Carga Horária' },
  ];
  isLoading: boolean = false; // Controle de loading para evitar múltiplas requisições
  ngOnInit() {
    if (this.curso) {
      this.loadPlanoCurricular(this.curso.id);
    }
    this.loadDisciplinas();
    this.loadTipoPeriodos();
  }

  onAccordionTabOpen(planoCurricularID: any, AnoCurricular: any) {
    this.loadPlanoCurricularDisciplinas(planoCurricularID, AnoCurricular + 1);
  }

  editDisciplina(disciplina: any) {
    this.disciplina = disciplina;
    this.visibleDisciplinaForm = true;
  }

  loadDisciplinas() {
    this.disciplinaService.list().subscribe((res) => {
      this.disciplinaOptions = res?.data?.map((disciplina: any) => ({
        label: disciplina.designacao,
        value: disciplina.id,
      }));
    });
  }

  loadPeriodos(TipoPeriodoID: number) {
    console.log('Carregando períodos para TipoPeriodoID:', this.isLoading);
    if (this.isLoading) return; // Evita múltiplas requisições simultâneas
    this.isLoading = true;
    this.periodoService
      .list({
        TipoPeriodoID: TipoPeriodoID,
      })
      .subscribe((res) => {
        this.isLoading = false; // Reseta o loading após a requisição
        this.periodoList = res?.map((periodo: any) => ({
          label: periodo.designacao,
          value: periodo.id,
        }));
      });
  }
  onTipoPedidoChange(event: any) {
    this.isLoading = false;
    this.loadPeriodos(event);
  }

  loadTipoPeriodos() {
    this.tipoPeriodoService.list().subscribe((res) => {
      this.tipoPeriodoList = res?.map((tipoPeriodo: any) => ({
        label: tipoPeriodo.designacao,
        value: tipoPeriodo.id,
      }));
    });
  }

  loadPlanoCurricular(InstituicaoDeEnsinoCursoID: number) {
    this.planoCurricularService
      .list({ InstituicaoDeEnsinoCursoID })
      .pipe(
        finalize(() => {
          // this.loadPlanoCurricularDisciplinas(this.planoCurricular?.id);
        }),
      )
      .subscribe((response) => {
        const res = response?.data;
        if (res && res.length > 0) {
          this.planoCurricular = res[0];
        }
      });
  }

  loadPlanoCurricularDisciplinas(
    planoCurricularID?: number,
    AnoCurricular?: number,
  ) {
    this.pagination = new Pagination<any>().deserialize([]);
    this.planoCurricularDisciplinaService
      .list({
        PlanoCurricularID: planoCurricularID || this.planoCurricular?.id,
        AnoCurricular: AnoCurricular,
      })
      .subscribe((response) => {
        this.pagination = new Pagination<any>().deserialize(response);
      });
  }

  onPlanoCurricularSaved(event: any) {
    this.savePlanoCurricular(event);
  }

  savePlanoCurricular(planoCurricular?: any) {
    const formValue = {
      ...planoCurricular,
      InstituicaoDeEnsinoCursoID: this.curso.id,
    };
    const operacao =
      planoCurricular?.id && planoCurricular?.id !== '0'
        ? this.planoCurricularService.update(formValue)
        : this.planoCurricularService.store(formValue);

    operacao.subscribe({
      next: () => {
        this.visiblePlanoCurricularForm = false;
        this.loadPlanoCurricular(this.curso.id);
        this.ref.close(true);
      },
      error: (err) => {
        console.error('Erro ao salvar plano curricular:', err);
      },
    });
  }

  onDisciplinaSaved(event: any) {
    const formValue = { ...event };
    this.savePlanoCurricularDisciplina(formValue);
  }

  savePlanoCurricularDisciplina(disciplina: any): void {
    const isNovaDisciplina = disciplina?.isNewDisciplina;

    const operacao: Observable<any> = isNovaDisciplina
      ? this.disciplinaService.storeDisciplinaPlanoCurricular(disciplina)
      : disciplina?.id && disciplina?.id !== '0'
        ? this.planoCurricularDisciplinaService.update(disciplina)
        : this.planoCurricularDisciplinaService.store(disciplina);
    operacao.subscribe({
      next: (res: any) => {
        if (res.retorno.codigo === 200) {
          this.handleSaveSuccess(disciplina);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao salvar disciplina!',
          });
        }
      },
      error: (err: any) => {
        console.error('Erro ao salvar plano curricular:', err);
      },
    });
  }

  private handleSaveSuccess(disciplina: any): void {
    this.visibleDisciplinaForm = false;
    this.visiblePlanoCurricularForm = false;
    this.ref.close(true);

    // Exibe mensagem de sucesso usando ConfirmationService
    this.messageService.add({
      severity: 'success', // opcional, para definir cor (success, info, warn, error)
      summary: 'Sucesso',
      detail: 'Disciplina salva com sucesso!',
      life: 3000, // duração do toast em ms (opcional)
    });

    this.loadPlanoCurricular(this.curso.id); // Recarrega os dados do plano curricular
    this.loadPlanoCurricularDisciplinas(
      this.planoCurricular?.id,
      disciplina?.anoCurricular,
    );
  }

  showDisciplinaDialog(anoCurricular: number) {
    this.visibleDisciplinaForm = true;
    this.visiblePlanoCurricularForm = false;
  }

  confirmarRemocaoDisciplina(disciplina: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja remover esta disciplina?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.planoCurricularDisciplinaService.delete(disciplina.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Disciplina removida com sucesso!',
            });
            this.loadPlanoCurricularDisciplinas(
              this.planoCurricular?.id,
              disciplina?.anoCurricular,
            );
          },
          error: (err) => {
            console.error('Erro ao remover disciplina:', err);
          },
        });
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
  }

  abrirPlanoCurricular() {
    this.visibleDisciplinaForm = false;
    this.visiblePlanoCurricularForm = true;
  }

  abrirDisciplina() {
    this.visiblePlanoCurricularForm = false;
    this.visibleDisciplinaForm = true;
  }
}
